import { render, staticRenderFns } from "./EditOrderStatusForm.vue?vue&type=template&id=b9688f70&"
import script from "./EditOrderStatusForm.vue?vue&type=script&lang=js&"
export * from "./EditOrderStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports